import { DetailsControlType } from 'shared/details-page/details-control/details-control-type';

export const editableInCellColumns: any = {
  'qty': {
    'fieldMap': 'qty',
    'itemName': 'assignment_values.qty',
    'controlType': DetailsControlType.Select,
  },
  'position': {
    'fieldMap': 'position_id',
    'itemName': 'assignment_values.position_id',
    'controlType': DetailsControlType.Select,
  }
};
